import { useState, useEffect } from 'react';
import styles from '../../styles/modules/building/BuildingObjectsPicker.module.scss';

const BuildingObjectsPicker = ({ onChange }) => {
  const [selectedType, setSelectedType] = useState('list');

  useEffect(() => {
    if (onChange) {
      onChange(selectedType);
    }
  }, [selectedType]);

  return (
    <div className={styles.group}>
      <button
        type="button"
        className={selectedType === 'list' && styles.active}
        onClick={() => setSelectedType('list')}
      >
        Список
      </button>
      <button
        type="button"
        className={selectedType === 'table' ? styles.active : null}
        onClick={() => setSelectedType('table')}
      >
        Шахматка
      </button>
    </div>
  );
};

export default BuildingObjectsPicker;
